import styled from 'styled-components';
import Flex from '../Flex';

export const LoaderWrapper = styled(Flex)`
  height: 100vh;
  align-items: center;
  justify-content: center;
`;
